export const ATIVIDADES_OPTIONS = [
  { value: 'administrador', label: 'Administrador' },
  { value: 'advogado', label: 'Advogado' },
  { value: 'agente_vendas', label: 'Agente de Vendas' },
  { value: 'analista_sistemas', label: 'Analista de Sistemas' },
  { value: 'aposentado', label: 'Aposentado' },
  { value: 'arquiteto', label: 'Arquiteto' },
  { value: 'artista', label: 'Artista' },
  { value: 'assistente_administrativo', label: 'Assistente Administrativo' },
  { value: 'assistente_social', label: 'Assistente Social' },
  { value: 'autonomo', label: 'Autônomo' },
  { value: 'bancario', label: 'Bancário' },
  { value: 'barbeiro', label: 'Barbeiro' },
  { value: 'cabeleireiro', label: 'Cabeleireiro' },
  { value: 'comerciante', label: 'Comerciante' },
  { value: 'contador', label: 'Contador' },
  { value: 'cozinheiro', label: 'Cozinheiro' },
  { value: 'dentista', label: 'Dentista' },
  { value: 'designer', label: 'Designer' },
  { value: 'do_lar', label: 'Do Lar' },
  { value: 'economista', label: 'Economista' },
  { value: 'educador', label: 'Educador' },
  { value: 'eletricista', label: 'Eletricista' },
  { value: 'empresario', label: 'Empresário' },
  { value: 'enfermeiro', label: 'Enfermeiro' },
  { value: 'engenheiro', label: 'Engenheiro' },
  { value: 'estudante', label: 'Estudante' },
  { value: 'farmaceutico', label: 'Farmacêutico' },
  { value: 'fisioterapeuta', label: 'Fisioterapeuta' },
  { value: 'fotografo', label: 'Fotógrafo' },
  { value: 'funcionario_publico', label: 'Funcionário Público' },
  { value: 'gerente', label: 'Gerente' },
  { value: 'jornalista', label: 'Jornalista' },
  { value: 'mecanico', label: 'Mecânico' },
  { value: 'medico', label: 'Médico' },
  { value: 'militar', label: 'Militar' },
  { value: 'motorista', label: 'Motorista' },
  { value: 'nutricionista', label: 'Nutricionista' },
  { value: 'operador_maquinas', label: 'Operador de Máquinas' },
  { value: 'pedagogo', label: 'Pedagogo' },
  { value: 'pedreiro', label: 'Pedreiro' },
  { value: 'pensionista', label: 'Pensionista' },
  { value: 'pintor', label: 'Pintor' },
  { value: 'policial', label: 'Policial' },
  { value: 'professor', label: 'Professor' },
  { value: 'psicologo', label: 'Psicólogo' },
  { value: 'publicitario', label: 'Publicitário' },
  { value: 'recepcionista', label: 'Recepcionista' },
  { value: 'secretario', label: 'Secretário' },
  { value: 'seguranca', label: 'Segurança' },
  { value: 'servicos_gerais', label: 'Serviços Gerais' },
  { value: 'soldador', label: 'Soldador' },
  { value: 'tecnico_informatica', label: 'Técnico em Informática' },
  { value: 'tecnico_enfermagem', label: 'Técnico em Enfermagem' },
  { value: 'transportador', label: 'Transportador' },
  { value: 'vendedor', label: 'Vendedor' },
  { value: 'veterinario', label: 'Veterinário' },
  { value: 'outros', label: 'Outros' }
];

export const ATIVIDADES_MAP = Object.fromEntries(
  ATIVIDADES_OPTIONS.map(option => [option.value, option.label])
);

export const getAtividadeLabel = (value: string): string => {
  return ATIVIDADES_MAP[value] || value;
}; 